const siderBar = {
  profile: "Profil",
  history: "Geschichte",
  setting: "Einstellung",
  promotion: "Werbeaktion",
};

export default siderBar;